import { render, staticRenderFns } from "./PageScreenPay.vue?vue&type=template&id=72e5546a&scoped=true"
import script from "./PageScreenPay.vue?vue&type=script&lang=ts"
export * from "./PageScreenPay.vue?vue&type=script&lang=ts"
import style0 from "./PageScreenPay.vue?vue&type=style&index=0&id=72e5546a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e5546a",
  null
  
)

export default component.exports